import { AgmCoreModule } from '@agm/core';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { CKEditorModule } from 'ckeditor4-angular';

import { NgxSpinnerModule } from 'ngx-spinner';
import { ViewportScroller } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { HttpClientModule } from '@angular/common/http';

import { MAT_RIPPLE_GLOBAL_OPTIONS, RippleGlobalOptions  } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { NoopAnimationsModule } from '@angular/platform-browser/animations';
import { ServerTransferStateModule } from '@angular/platform-server';
import { Router } from '@angular/router';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { GraphQLModule } from './graphql.module';
import { AccountPayRequestsModule } from './modules/dashboard/modules/account-pay-requests/account-pay-requests.module';
import { BidsModule } from './modules/dashboard/modules/bids/bids.module';
import { PreOwnedOrdersModule } from './modules/dashboard/modules/pre-owned-orders/pre-owned-orders.module';
import { PreOwnedSuppliesModule } from './modules/dashboard/modules/pre-owned-supplies/pre-owned-supplies.module';
import { FeedsModule } from './modules/feeds/feeds.module';

import { LoginComponent } from './modules/home/components/login/login.component';
import { SignUpModule } from './modules/sign-up/sign-up.module';
import { MAT_TABS_CONFIG } from '@angular/material/tabs';
import { NgxStripeModule } from 'ngx-stripe';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';


import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatRadioModule } from '@angular/material/radio';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatCardModule } from '@angular/material/card';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AlertModalComponent } from './shared/modules/components/alert-modal/alert-modal.component';
import { LearningHubModule } from './modules/learning-hub/learning-hub.module';
import { MatChipsModule } from '@angular/material/chips';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { MatSelectModule } from '@angular/material/select';




const globalRippleConfig: RippleGlobalOptions = {
  disabled: true
};
@NgModule({
  declarations: [
    AppComponent,
    AlertModalComponent
  ],
  imports: [
    MatDialogModule,
    MatIconModule,
    MatButtonModule,
    BrowserModule.withServerTransition({ appId: 'serverApp' }),
    AppRoutingModule,
    BrowserModule,
    NoopAnimationsModule,
    BrowserAnimationsModule,
    ServerTransferStateModule,
    GraphQLModule,
    HttpClientModule,
    CKEditorModule,
    SignUpModule,
    NgxSpinnerModule,
    PreOwnedSuppliesModule,
    PreOwnedOrdersModule,
    BidsModule,
    AccountPayRequestsModule,
    ReactiveFormsModule,
    MatRadioModule,
    MatNativeDateModule,
    MatDatepickerModule,
    MatInputModule,
    MatFormFieldModule,
    MatCheckboxModule,
    MatCardModule,
    MatTooltipModule,
    MatChipsModule,
    FormsModule,
    NgxMatSelectSearchModule,
    MatSelectModule,

    NgxStripeModule.forRoot('pk_test_51RmSGtFl6A4EMn9bKM99mGjRpPpldnTLgVjChRwSQ9OjWiBkbkmCaMxmKNUXasDsxShE2iVCxKKm5OqYla4GO7Ky00deXVnuW2'),

    // AIzaSyB-euv3ls1ClVHd2SmYvdLPA6sB6_wnfkM
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyD1lCyCP4Qyq9nfuTVBGQnNovwntdcYqY0',
      libraries: ['geometry','places']
    }),
          FeedsModule,
          LearningHubModule

  ],
  providers: [
    {provide: MAT_RIPPLE_GLOBAL_OPTIONS, useValue:     globalRippleConfig},
    { provide: MAT_TABS_CONFIG, useValue: { animationDuration: '0ms' } }

  ],
  bootstrap: [AppComponent],
  entryComponents: [LoginComponent]

})
export class AppModule {

  constructor(private router: Router, private viewportScroller: ViewportScroller) {

    this.router.events.pipe(
      // filter((e: Event): e is Scroll => e instanceof Scroll)
    ).subscribe(e => {
      if (this.router.url.includes('/home/products/details')) {
        this.viewportScroller.scrollToPosition([0, 0]);
      } else if (this.router.url.includes('/home/products')) {
        // nothing to do
      } else {
        this.viewportScroller.scrollToPosition([0, 0]);
      }
    });
  }
}
